export default [
  {
    path: '/ProductList',
    name: 'ProductList',
    component: () => import('@/components/functions/M0006OnlineShop/M0006OnlineShopIndex')
  },
  {
    path: '/Product/:id/:name',
    name: 'Product',
    component: () => import('@/components/functions/M0006OnlineShop/M0006OnlineShopProductDetail')
  },
  {
    path: '/ShoppingCart',
    name: 'ShoppingCart',
    component: () => import('@/components/functions/M0008ShoppingCart/CartIndex')
  },
  {
    path: '/CheckOut',
    name: 'CheckOut',
    component: () => import('@/components/functions/M0009CheckOut/CheckOutIndex')
  },
  {
    path: '/ShoppingCart/:status',
    name: 'Payment',
    component: () => import('@/components/functions/M0008ShoppingCart/CartIndex')
  },
  {
    path: '/PurchaseDetail/Received/:p0201_id/:purchase_num/:temp_token',
    name: 'PurchaseDetail',
    component: () => import('@/components/functions/M0009CheckOut/PurchaseReceived')
  },
  {
    path: '/',
    name: 'HomePage',
    component: () => import('@/components/functions/M0006OnlineShop/M0006OnlineShopIndex')
  },
  {
    path: '*',
    redirect: '/'
  }
]
